var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66895 4.89258V4.89911",
    stroke: "#3D2C06",
    strokeWidth: 1.22314,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11523 4.89258V4.89911",
    stroke: "#3D2C06",
    strokeWidth: 1.22314,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56174 4.89232V4.89844M9.78488 0.611328C10.2715 0.611328 10.7381 0.804627 11.0822 1.1487C11.4263 1.49278 11.6196 1.95944 11.6196 2.44604V7.3386C11.6196 7.8252 11.4263 8.29186 11.0822 8.63594C10.7381 8.98001 10.2715 9.17331 9.78488 9.17331H6.72703L3.66918 11.008V9.17331H2.44604C1.95944 9.17331 1.49278 8.98001 1.1487 8.63594C0.804627 8.29186 0.611328 7.8252 0.611328 7.3386V2.44604C0.611328 1.95944 0.804627 1.49278 1.1487 1.1487C1.49278 0.804627 1.95944 0.611328 2.44604 0.611328H9.78488Z",
    stroke: "#3D2C06",
    strokeWidth: 1.22314,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.9aefb6bf41b0857ee88e7f36d33b1a73.svg";
export { ForwardRef as ReactComponent };